/**
 * Resolve the workspace key (`id_client`) a request should scope to.
 *
 * `id_client` on the user profile is a map keyed by workspace
 * (`{ ko_global: {...}, pepsi_fr: {...} }`), or a bare string on the legacy
 * profile shape. Resolution order on the map shape:
 *
 * 1. The selected workspace, when the map holds it. The selection may be the
 *    `{ key, value }` switcher entry or a bare key.
 * 2. `fallbackIdClient`, the id the auth slice has already resolved. A
 *    grant-less Dashmote staffer carries an empty map, so this is what keeps
 *    their selected workspace from falling through to step 3.
 * 3. The first key in the map.
 *
 * On the legacy shape it returns `fallbackIdClient`, then `company`, then the
 * string itself.
 */
export const extractClientId = (
  userData: any,
  selectedWorkspace: { key?: string } | string | null = null,
  fallbackIdClient: string | null = null
): string | undefined => {
  if (userData.id_client && typeof userData.id_client === "object") {
    const workspaceKey =
      typeof selectedWorkspace === "string"
        ? selectedWorkspace
        : selectedWorkspace?.key;

    if (workspaceKey && userData.id_client[workspaceKey]) {
      return workspaceKey;
    }
    if (fallbackIdClient) {
      return fallbackIdClient;
    }
    return Object.keys(userData.id_client)[0];
  }
  return fallbackIdClient || userData.company || userData.id_client;
};
